module.exports = __webpack_public_path__ + "bRIe_XFrtjaX0I2nF/rdc_pro_logo.svg";